import { nextTrpc } from '@/lib/trpc'
import Loader from '@/components/Loader'
import { withAuth } from '@/lib/hocs/withAuth'
import ReleaseManagementTable from '@/components/tables/ReleaseManagementTable'
import useLocalStorage from '@rehooks/local-storage'

function ReleasesPage() {
  // const router = useRouter()
  // const selectedArtistId = '00a0931d-7e80-4f06-a855-e9b1ecc0e18b'
  const [ selectedArtistId ] = useLocalStorage<string>('selectedArtistId')
  const { data: artist, isFetched: hasArtistBeenFetched } = nextTrpc.artist.get.useQuery(
    { artistId: selectedArtistId as string },
    { enabled: !!selectedArtistId }
  )

  const { data } = nextTrpc.release.getAll.useQuery({ artistId: artist?.id ?? '' })

  console.log('DATA', data)

  // TODO: write a query that only gets what is needed
  // const { data: users } = nextTrpc.user.getAll.useQuery({ artistId: artist?.id }, { enabled: !!artist })
  // const { data: invites } = nextTrpc.invite.getAll.useQuery({ artistId: artist?.id }, { enabled: !!artist })

  // useEffect(() => {
  //   if (hasArtistBeenFetched && !artist || !selectedArtistId) router.push('/')
  // }, [ artist && hasArtistBeenFetched, selectedArtistId ])

  if (!artist || !data?.baseReleases || !data?.mixReleases) return <Loader />

  return (
    <div className="flex h-full flex-col gap-8 lg:gap-4">
      {/* @ts-ignore */}
      <ReleaseManagementTable releases={{ ...data }} artist={artist} />
    </div>
  )
}

export default withAuth('logged-in', ReleasesPage)
